"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signer = exports.Nep413MessageSchema = void 0;
exports.Nep413MessageSchema = {
    struct: {
        message: 'string',
        nonce: { array: { type: 'u8', len: 32 } },
        recipient: 'string',
        callbackUrl: { option: 'string' },
    },
};
/**
 * General signing interface, can be used for in memory signing, RPC singing, external wallet, HSM, etc.
 */
class Signer {
}
exports.Signer = Signer;
